import type { ReactNode } from 'react'

type Props = {
  title: string
  /** Строка под названием: что будет, если нажать. */
  hint?: string
  icon: ReactNode
  disabled?: boolean
  onClick: () => void
}

/**
 * Крупная кнопка главного меню.
 *
 * Настольная игра начинается с выбора «во что играем», а не с формы: раньше
 * на главной лежали две карточки с полями и кнопками, и первым делом человек
 * читал подписи, вместо того чтобы нажать одну кнопку. Здесь наоборот —
 * сначала действие, подробности вторым шагом.
 */
export function MenuButton({ title, hint, icon, disabled, onClick }: Props) {
  return (
    <button className="menu-btn" type="button" disabled={disabled} onClick={onClick}>
      <span className="menu-btn__icon" aria-hidden="true">
        {icon}
      </span>
      <span className="menu-btn__text">
        <span className="menu-btn__title">{title}</span>
        {hint !== undefined && <span className="menu-btn__hint">{hint}</span>}
      </span>
      <span className="menu-btn__go" aria-hidden="true">
        ›
      </span>
    </button>
  )
}
